var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "baseForm",
      staticStyle: { width: "100%" },
      attrs: {
        model: _vm.baseForm,
        rules: _vm.rules,
        size: "small",
        "label-width": "100px",
        "label-position": "right",
      },
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "客户姓名", prop: "name" } },
                [_c("span", [_vm._v(_vm._s(_vm.baseForm.name || "-"))])]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "客户电话", prop: "mobile" } },
                [_c("span", [_vm._v(_vm._s(_vm.baseForm.mobile || "-"))])]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "微信", prop: "custWechat" } },
                [_c("span", [_vm._v(_vm._s(_vm.baseForm.custWechat || "-"))])]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "带单人", prop: "inviter" } },
                [_c("span", [_vm._v(_vm._s(_vm.baseForm.inviter || "-"))])]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "客户地址", prop: "address" } },
                [_c("span", [_vm._v(_vm._s(_vm.baseForm.address || "-"))])]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "客户来源", prop: "msgFrom" } },
                [_c("span", [_vm._v(_vm._s(_vm.baseForm.msgFrom || "-"))])]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { "white-space": "nowrap" },
                  attrs: { label: "是否经销商区域", prop: "isDistributor" },
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.baseForm.isDistributor || "-")),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }